module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionCwcj.c8844fee.png";